import React, { useContext } from "react";
import { t } from "i18next";
import ModalMain from "../../../../../components/Modal/ModalMain";
import ModalHeader from "../../../../../components/Modal/ModalHeader";
import ModalFooter from "../../../../../components/Modal/ModalFooter";
import themeContext from "../../../../../context/theme/ThemeContext";

/**
 * Popup shown when radiologist clicks Preliminary.
 * - Continue → /save
 * - Release → /save then /study/releasePreliminaryStudy
 * - Ready for Review & Release → /save then release with readyForReview=true
 */
const PreliminaryActionModal = ({
  isOpen,
  onClose,
  onContinue,
  onRelease,
  onReadyForReviewAndRelease,
}) => {
  const { getThemeColor } = useContext(themeContext);

  if (!isOpen) {
    return null;
  }

  const DefaultButtonList = [
    {
      title: t("button.continue"),
      onclick: onContinue,
    },
    {
      title: t("button.release"),
      onclick: onRelease,
    },
    {
      title: t("button.ready-for-review-and-release"),
      onclick: onReadyForReviewAndRelease,
    },
  ];
  const splitLabel = (text) => {
  const [label, ...rest] = text.split(" — ");
  return { label, description: rest.join(" — ") };
};
  const modalDetails = {
    header: (
      <ModalHeader
        updatedModal={true}
        heading={t("button.preliminary")}
        handleCancel={onClose}
      />
    ),
body: (
  <div
    className="global-modal-body"
    style={{ color: getThemeColor("primary-color"), fontSize: "13px" }}
  >
    <p style={{ marginBottom: "8px", fontWeight: "bold", fontSize: "13px" }}>
      {t("confirm-message.preliminary-actions-description")}
    </p>
    <ul style={{ margin: 0, paddingLeft: "20px" }}>
      {(() => {
        const cont = splitLabel(t("confirm-message.preliminary-action-continue"));
        const rel = splitLabel(t("confirm-message.preliminary-action-release"));
        const ready = splitLabel(t("confirm-message.preliminary-action-ready-for-review"));
        return (
          <>
            <li style={{ marginBottom: "6px", lineHeight: 1.4 }}>
              <strong style={{ fontSize: "13px" }}>{cont.label}</strong> : {cont.description}
            </li>
            <li style={{ marginBottom: "6px", lineHeight: 1.4 }}>
              <strong style={{ fontSize: "13px" }}>{rel.label}</strong> : {rel.description}
            </li>
            <li style={{ lineHeight: 1.4 }}>
              <strong style={{ fontSize: "13px" }}>{ready.label}</strong> : {ready.description}
            </li>
          </>
        );
      })()}
    </ul>
  </div>
),
    footer: (
      <ModalFooter
        PrimaryButtonList={[]}
        DefaultButtonList={DefaultButtonList}
      />
    ),
    width: "500px",
  };

  return (
    <ModalMain
      updatedModal={true}
      showModal={isOpen}
      modalDetails={modalDetails}
    />
  );
};

export default PreliminaryActionModal;
